module.exports = __webpack_public_path__ + "media/images/home-banners/westboundary-photography-chris-gill-60180-unsplash-259013b6c1374cc04f06dabf0ae4d1b1.jpg";